// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"040e66bd","2606":"25ebab3f","3873":"276cb172","4483":"969413a6","6694":"047c4067","9155":"5874824e","9982":"bd23a02f","9994":"04cfab3c"}[chunkId] + ".css";
};